import {myDocumentsState} from "./state";
import {loadDocumentsAction} from "./effects";
import {loadDocumentsSuccessAction} from "./reducer";
import {createSelector} from "@rematch/select";

export const models = {
  state: myDocumentsState,
  reducers: {
    reset: (state) => myDocumentsState,
    setLoadingAction: (state) => ({...state, isLoading: true}),
    setSearchTermAction: (state, searchTerm) => ({...state, searchTerm: searchTerm}),
    loadDocumentsSuccessAction
  },
  effects: dispatch => ({
    loadDocumentsAction: function (_, state) {
      dispatch.myDocuments.setLoadingAction();
      return loadDocumentsAction.call(this, state, dispatch);
    },
  }),
  selectors: (slice) => ({
    documents() {
      return createSelector(
        this.allDocuments,
        this.searchTerm,
        (docs, searchTerm) => {
          if (!searchTerm?.length) return docs;
          return docs.filter(doc =>
            doc?.vin?.toLowerCase()?.includes(searchTerm.toLowerCase()) ||
            doc.patente?.toLowerCase()?.includes(searchTerm.toLowerCase())
          )
        }
      );
    },
    allDocuments() {
      return slice((myDocs) => myDocs.documents);
    },
    isLoading() {
      return slice((myDocs) => myDocs.isLoading);
    },
    searchTerm() {
      return slice((myDocs) => myDocs.searchTerm);
    },
  }),
};
